module.exports = __webpack_public_path__ + "static/media/6930.8ac1154c.jpg";